// extracted by mini-css-extract-plugin
module.exports = {"button":"supplier_button_2qWPn","buttonIcon":"supplier_buttonIcon_12b5z"};